import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { CreateProductGroupingInput } from './CreateProductGroupingInput';
import { CreateProductGroupingOutput } from './CreateProductGroupingOutput';

export class CreateProductGroupingService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: CreateProductGroupingInput): Promise<Result<CreateProductGroupingOutput> | null> => {
    const promise = this.http.post<Result<CreateProductGroupingOutput>, CreateProductGroupingInput>(`${this.baseUrlSislogApi}/v2/product-grouping/create`, input);
    return promise;
  }
}